import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requireAdmin = true }) {
  const { user, loading, profileChecked, session, profile } = useAuth();
  const location = useLocation();

  if (loading || (session && !profileChecked)) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-ink/50" data-testid="auth-loading">
        Checking session...
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace state={{ from: location }} />;
  if (requireAdmin && !user.is_admin) {
    const debug = {
      auth_user_id: session?.user?.id ?? null,
      session_email: session?.user?.email ?? null,
      profile_row_returned: profile,
      profile_is_admin: profile?.is_admin ?? null,
      hint: profile === null
        ? "RLS likely blocking the SELECT on profiles. Verify policies + that auth.uid() matches profiles.id."
        : "Profile row returned but is_admin is not true. Set is_admin=true in the profiles table.",
    };
    return (
      <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6">
        <p className="font-display text-2xl text-ink">Account not authorized</p>
        <p className="text-ink/60 mt-2 max-w-sm">This account doesn&apos;t have admin access. Please contact the site owner.</p>
        <p className="text-ink/40 mt-4 text-xs">Signed in as {user.email}</p>
        <details className="mt-8 max-w-xl w-full text-left">
          <summary className="text-xs text-ink/40 cursor-pointer hover:text-ink/60">Debug info (for the site owner)</summary>
          <pre className="mt-3 p-4 bg-white border border-ink/10 rounded-lg text-[11px] text-ink/70 overflow-auto whitespace-pre-wrap break-all">
{JSON.stringify(debug, null, 2)}
          </pre>
        </details>
      </div>
    );
  }
  return children;
}
